import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FilterService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { BillingOrder } from 'src/app/models/billingorder.model';
import { OrderStatus } from 'src/app/models/constants';
import { ScrBaseService } from 'src/app/services/base.service';
import { BillingService } from 'src/app/services/billing.service';
import { PaymentService } from 'src/app/services/payment.service';
import { IuiMessagesComponent, Message } from 'src/app/shared/messages/messages.component';
import { ShortCodesService } from 'src/app/services/shortcodes.service';

export interface ResultsEvent {
  results: BillingOrder[];
}
@Component({
  selector: 'app-order-list',
  templateUrl: './view-orders.component.html',
  styleUrls: ['./view-orders.component.scss']
})
export class ViewOrdersComponent extends ScrBaseComponent implements OnInit {

  public orderList: BillingOrder[] = [];
  public unFilteredOrderList: BillingOrder[] = [];
  public searchLockdown = false;
  public latestOrderList: BillingOrder[] = [];
  public scIdMap = new Map<number, number>();
  public checked = false;
  public clearSearchIcon = true;
  public searchInput = '';
  public orderColumns: { field: string, header: string, width: number, sorting: boolean }[] = [
    { field: 'orderId', header: 'Order ID', width: 9, sorting: true },
    { field: 'orderStatus', header: 'Order Status', width: 7, sorting: true },
    { field: 'numberOfCodes', header: 'Short Codes', width: 7, sorting: true },
    { field: 'totalPrice', header: 'Total Price', width: 10, sorting: true },
    { field: 'invoiceDate', header: 'Invoice Date', width: 9, sorting: true },
    { field: 'paymentDueDate', header: 'Due Date', width: 9, sorting: true },
    { field: 'paymentReceivedDate', header: 'Paid Date', width: 9, sorting: true },
    { field: 'paymentMethod', header: 'Payment Method', width: 9, sorting: true },
    { field: 'action', header: 'Action', width: 12, sorting: false }
  ];
  public expandedOrderColumns: { field: string, header: string, width: number, sorting: boolean }[] = [
    { field: 'scId', header: 'Short Code', width: 9, sorting: false },
    { field: 'leaseStatus', header: 'Lease Status', width: 9, sorting: false },
    { field: 'scExpirationDate', header: 'Expiration Date', width: 9, sorting: false },
    { field: 'term', header: 'Term', width: 9, sorting: false },
    { field: 'startDate', header: 'Start Date', width: 9, sorting: false },
    { field: 'endDate', header: 'End Date', width: 9, sorting: false },
    { field: 'price', header: 'Price', width: 9, sorting: false },
    { field: 'parentOrderId', header: 'Previous Order', width: 9, sorting: false }
  ];
  @ViewChild('tt', { static: false }) tt!: Table;
  @ViewChild('globalSearch', { static: false }) globalSearch!: ElementRef;
  @ViewChild('messages', { static: false }) messages!: IuiMessagesComponent;
  @Input() listApi = 'default';

  @Output() resultsLoaded = new EventEmitter<ResultsEvent>();

  selectedOrderLeaseCount = 0;
  public ordersForCart: BillingOrder[] = [];

  constructor(
    private billingService: BillingService,
    private router: Router,
    private primengFilterService: FilterService, private paymentService: PaymentService,
    private shortCodesService: ShortCodesService,) { super(); }

  determineListApi() {
    if (this.listApi.toLowerCase() === 'needspayment') {
      return this.billingService.getOrders(this.listApi.toLowerCase());
    } else {
      return this.billingService.getOrders();
    }
  }


  ngOnInit(): void {
   

    if (this.listApi.toLowerCase() === 'needspayment') {
      this.orderColumns = this.orderColumns.filter(c => {
        return (c.field !== 'paymentReceivedDate' && c.field !== 'paymentMethod');
      });
    }

    this.primengFilterService.register('array-some', this.arraySomeFilter);
    this.observe(this.determineListApi(), rsp => {
      this.unFilteredOrderList = rsp.orders.map(object => ({ ...object }));
      this.orderList = rsp.orders;
      this.checkForLatest(this.orderList);
      rsp.orders.forEach(order => {
        order.isExpansionDisplay=false;
        order.leases.forEach(lease => {
          this.scIdMap.set(lease.scId, order.orderId);
          
        

        });
      });

   
      if (this.resultsLoaded) {
        this.resultsLoaded.emit({ results: this.orderList });
      }
      setTimeout(() => {
        if (history.state?.orderId) {
          if (history.state?.needBackend) {
            const orderId = history.state?.orderId.toString();
            this.checked = false;
            this.searchInput = orderId;
            this.searchBackend(orderId);
            this.searchLockdown = true;
          } else {
            this.globalSearch.nativeElement.value = history.state.orderId;
            this.tt.filterGlobal(history.state.orderId, 'contains');
          }
        }
        if (history.state?.scId) {
          if (history.state?.needBackend) {
            const scId = history.state?.scId.toString();
            this.checked = true;
            this.searchInput = scId;
            this.searchBackend(scId);
          } else {
            this.checked = true;
            this.globalSearch.nativeElement.value = history.state.scId;
            this.tt.filterGlobal(history.state.scId, 'contains');
          }
        }
      }, 500);
      return false;
    });
  }

  arraySomeFilter(value: number, filter: number[]) {
    if (filter === undefined || filter === null || filter.length === 0) {
      return true;
    }

    if (value === undefined || value === null) {
      return true;
    }

    return filter.includes(value);
  }

  customSCFilter(event: Event) {
    const target = event.target as HTMLInputElement;

    // search the table using short code.
    const scId = ScrBaseService.shortCodeToNumeric(target.value);
    this.scIdMap.entries();
    const possibleOrderIds: number[] = [];
    for (const [key, value] of this.scIdMap) {
      if (`${key}`.includes(scId)) {
        possibleOrderIds.push(value);
      }
    }

    if (possibleOrderIds.length > 0 && scId !== '') {
      this.tt.filterGlobal(possibleOrderIds, 'array-some');
    } else if (this.searchInput !== '') {
      this.tt.filterGlobal('A', 'equals');
    } else {
      this.tt.filterGlobal('', 'contains');
    }
  }

  onSlide(): void {
    if (!this.checked) {
      this.searchInput = '';
      if (this.searchLockdown) {
        this.resetBackendSearch();
      } else {
        this.tt.filterGlobal('', 'contains');
      }
    }
    if (this.checked) {
      this.searchInput = '';
      if (this.searchLockdown) {
        this.resetBackendSearch();
      } else {
        this.tt.filterGlobal('', 'contains');
      }
    }
  }

  resetBackendSearch() {
    this.searchLockdown = false;
    this.clearSearchIcon = false;
    this.orderList = [];
    setTimeout(() => {
      this.orderList = this.unFilteredOrderList;
      this.clearSearchIcon = true;
    });
    this.searchInput = '';
    this.tt.filterGlobal('', 'contains');
  }

  searchBackend(id: string) {
    this.clearMessages();
    if (this.checked) {
      if (this.searchInput.length >= 5 && ScrBaseService.shortCodeToNumeric(this.searchInput[0]) !== '0' && ScrBaseService.shortCodeToNumeric(this.searchInput[0]) !== '1') {
        this.observe(this.billingService.searchAdditionalOrderInfo('scId', ScrBaseService.shortCodeToNumeric(id)), rsp => {
          this.latestOrderList = this.orderList;
          this.searchLockdown = true;
          this.orderList = rsp.orders;
          this.checkForLatest(this.orderList);
          this.tt.filterGlobal('', 'contains');
          return false;
        });
      } else {
        this.messages.displayError(new Message('', 'The short code must be 5 or 6 alpha-numeric characters and in the numerical range 20000 ~ 99999 or 200000 ~ 999999'));
      }
    } else if (!this.checked) {
      const alreadyInList = this.orderList.some((object) => object.orderId.toString() === this.searchInput.toString());
      if (alreadyInList) {
        this.tt.filterGlobal(this.searchInput, 'contains');
      } else {
        if (this.searchInput.length >= 7) {
          this.observe(this.billingService.searchAdditionalOrderInfo('orderId', id), rsp => {
            this.latestOrderList = this.orderList;
            this.searchLockdown = true;
            this.orderList = rsp.orders;
            this.checkForLatest(this.orderList);
            this.tt.filterGlobal('', 'contains');
            return false;
          });
        } else {
          this.messages.displayError(new Message('', 'Order ID must be at least 7 digits long.'));
        }
      }
    }
  }

  viewInvoice(orderId: string) {
    this.router.navigate([
      '/dashboard',
      { outlets: { 'navbar-tab': ['billing', { outlets: { 'billing-tab': ['invoice', orderId] } }] } }
    ]);

    window.scrollTo(0, 0);
  }

  viewShortCode(scId: string) {
    this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['my-shortcodes', { outlets: { 'my-shortcode-tab': ['shortcode-list'] } }] } }], { state: { scId } });
  }

  goToPrevOrder(orderId: number) {
    const currentOrder = this.orderList.some(element => element.orderId === orderId);
    this.searchInput = `${orderId}`;
    if (currentOrder) {
      this.tt.filterGlobal(this.searchInput, 'contains');
    } else {
      this.observe(this.billingService.searchAdditionalOrderInfo('orderId', `${orderId}`), rsp => {
        this.latestOrderList = this.orderList;
        this.searchLockdown = true;
        this.orderList = rsp.orders;
        return false;
      });
      this.tt.filterGlobal(this.searchInput, 'contains');
    }
  }

  checkForLatest(orderList: BillingOrder[]) {
    orderList.forEach((element) => {
      element.active = element.leases.some(lease => lease.latestLease);
  
    });
  }


  addToCart(order: BillingOrder): void {

    if (this.ordersForCart.includes(order)) {
      this.ordersForCart = this.ordersForCart.filter(oo => oo !== order);
      order.isInCart = false;
    }
    else if (order.numberOfCodes + this.selectedOrderLeaseCount > 20) {
      this.displayWarningStyledAsError(`The system can process payment for a maximum of 20 short codes. You currently have ${this.ordersForCart.length} order(s) selected, containing a total of ${this.selectedOrderLeaseCount} short codes, and have attempted to select an order that will put the total number of selected short codes over that maximum. You can either deselect some of the orders, or complete payment on the currently selected orders and then return to this page to select additional orders for which to pay.`);
        
      // unselect it if too many
      setTimeout(() => {
        this.orderList.forEach((o) => {
          if (o.orderId === order.orderId) {
            o.selected = false;
          }
        });
      });
    }
    else if (!this.eligibleForMultiOrderPayment(order)) {
      this.displayWarningStyledAsError(`Order ${order.orderId} is not eligible for multi-order payments.`);
    }
    else {
      this.ordersForCart.push(order);
      order.isInCart = true;
    }
    this.selectedOrderLeaseCount = this.ordersForCart.reduce((v, p) => {
      return v + p.numberOfCodes;
    }, 0);
  }


  downloadTransferStatement(scId: number, orderId?: number) {
    this.observeDownloadOrAny(this.shortCodesService.getTransferDoc(scId, orderId), res => {
      this.shortCodesService.processBlobResponseDownload(res, 'application/pdf');
    });
  }

  public eligibleForMultiOrderPayment(order: BillingOrder): boolean {
    // if there is a one month term lease, return false
    
    return (this.listApi === 'needspayment' &&
      ((order.orderStatus === OrderStatus.PaymentDue || order.orderStatus === OrderStatus.PaymentOverdue) &&
        (order.leases.some(l => l.term === 1) === false)) && order.numberOfCodes<20);
  }

  payForSelectedOrders() {
    this.observe(this.paymentService.initiatePayment(this.ordersForCart), rsp => {
      // console.debug(JSON.stringify(rsp.payment));
      this.router.navigate(['dashboard', { outlets: { 'navbar-tab': ['payment'] } }], { state: { payment: rsp.payment } });
      return false;
    });
  }

  expansionShowHide(order: BillingOrder) {
    if(!order.isExpansionDisplay ){
     this.loadShortCodes(order.orderId);
     order.isExpansionDisplay = true;
   }
  

    
  }

  
  loadShortCodes(orderId: number) {

    this.observe(this.billingService.getShortCodeDetails(orderId), rsp => {
    

    this.checkForLatest(rsp?.orders);
     for (let i = 0; i < this.orderList.length; i++) {
        if (this.orderList[i].orderId == orderId) {
          this.orderList[i] = rsp?.orders[0];
          this.orderList[i].isExpansionDisplay = true;
          this.orderList = [...this.orderList];
       
            

      }}

      
    
 
      return false;
    });
  





  

}}
